import { AVAILABLE_LANGUAGES } from '@/store/useAppPreferencesStore'

export interface AvailableLanguageCardItem {
  name: string
  code?: string
  language_key: AVAILABLE_LANGUAGES
  imagePath: string // URL для флагов в веб-версии
}

export const availableLanguages: AvailableLanguageCardItem[] = [
  {
    name: 'English',
    code: 'EN',
    language_key: 'en',
    imagePath: '/assets/flags/us.png',
  },
  {
    name: 'العربية',
    code: 'ع',
    language_key: 'ar',
    imagePath: '/assets/flags/sa.png',
  },
  {
    name: 'Português',
    code: 'PT',
    language_key: 'pt',
    imagePath: '/assets/flags/br.png',
  },
  // {
  //   name: 'Русский',
  //   code: 'РУ',
  //   language_key: 'ru',
  //   imagePath: '', // TODO: добавить флаг России (ru.png)
  // },
]
